import type {User} from "@project/application/admin";

import {getUserQueryOptions} from "@project/application/admin";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../../messages/routes.messages";

import {UserPage} from "./-page/user.page";
import {UserPending} from "./-page/user.pending";

// ─── Route definition ─────────────────────────────────────────────────────────

export const Route = createFileRoute("/_app/admin/users/$userId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, params}) =>
    queryClient.ensureQueryData(getUserQueryOptions(params.userId)),
  pendingComponent: UserPending,
  staticData: {
    meta: {
      /**
       * Prefer loaded user name in breadcrumb trail.
       * If data is not ready yet, fall back to descriptor-safe route copy.
       */
      getLabel: (_p: Record<string, string>, data?: unknown) => (data as User | undefined)?.name,
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.userById.id,
        values: {userId: p["userId"]},
      }),
    },
  },
});

// ─── Route component wrapper ──────────────────────────────────────────────────

function RouteComponent() {
  const {userId} = Route.useParams();

  return <UserPage userId={userId} />;
}
